export default {
  addOns: 'Suplimente',
  availability: 'Disponibilitate',
  availabilityDaySelector: 'Selector de dată pentru disponibilitate',
  unavailable: 'Indisponibil',
  person: 'persoană',
  people: 'persoane',
  reserveNow: 'Rezervă acum',
  selectTime: 'Selectează ora',
  select: 'Selectează',
  reserve: 'Rezervă',
  time: 'Ora',
  tier: 'Nivel',
  questions: 'Întrebări',
  addToCart: 'Adaugă în coș',
  checkout: 'Plată',
  total: 'Total',
  whatsIncluded: 'Ce este inclus',
  showMore: 'Arată mai mult',
  showLess: 'Arată mai puțin',
  session: 'Sesiune',
  viewDetails: 'Vezi detalii',
  findAvailability: 'Găsește Disponibilitatea',
  loading: 'Se încarcă',
  capacity: 'Capacitate',
  noAvailableSessionsOnThisDate:
    'Nu există sesiuni disponibile în această dată',
  noGroupAvailableOnThisDateAndTime:
    'Nu există {{groupTitle}} disponibile la această dată și oră',
  noCollectionFound: 'Nu s-a găsit nicio colecție!',
  noResourceGroupFound: 'Nu s-a găsit niciun grup de resurse!',
  noData: 'Nu există date!',
  continue: 'Continuă',
  night: 'noapte',
  nights: 'nopți',
  noAvailableSessionsForSelectedDates:
    'Unele date din selecția dvs. nu au sesiuni disponibile. Vă rugăm să selectați alte date.',
  from: 'de la',
  dateRangeSelector: 'Selector de interval de date',
  priceTierRadioGroup: 'Selector de nivel de preț',
  startTime: 'Ora de început',
  duration: 'Durată',
  lengthOfStay: 'Durata sejurului',
  startDate: 'Data de început',
  endDate: 'Data de sfârșit',
  selectDates: 'Selectați datele',
  more: 'Mai multe',
  selectStartTime: 'Alegeți ora de început',
  endTime: 'Ora de sfârșit',
  selectEndTime: 'Alegeți ora de sfârșit',
  morning: 'Dimineață',
  afternoon: 'După-amiază',
  save: 'Salvați',
  selectDuration: 'Alegeți durata',
  forLength: 'pentru {{length}}',
  moreDates: 'încă {{count}}',
  addDate: 'Adăugați o dată',
  start: 'Început',
  end: 'Sfârșit',
  pickupFrom: 'Ridicare de la',
  returnBy: 'Returnare până la',
  day: 'zi',
  days: 'zile',
  hour: 'oră',
  hours: 'ore',
};
